import { ProfileIcon } from "@/components/layout/MainHeader";
import { StyledCommentDiv } from "./Style";
import { formatTimeDifference } from "@/lib/string-format-utils";
import { Button, Dropdown, Input, MenuProps, Modal } from "antd";
import { EllipsisOutlined } from "@ant-design/icons";
import { ChangeEvent, useCallback, useMemo, useState } from "react";
import {
  IconShareCommentDelete,
  IconShareCommentEdit,
} from "@/components/common/Icons";
import { useTranslation } from "next-i18next";

const TAG = "[ShareComment]";

export default function ShareComment({
  comment,
  userProjectPermission = "view",
  handleVideoTime,
  handleEditComment,
  handleDeleteComment,
}: {
  comment: CommentType;
  userProjectPermission: string;
  // userProjectPermission: 'view' | 'edit' | 'comment',
  handleVideoTime: (val: string) => void;
  handleEditComment: (val: {
    commentId: string;
    content: string;
    videoTime: string;
    type: string;
    projectId: string;
  }) => void;
  handleDeleteComment: (val: {
    commentId: string;
    projectId: string;
    type: string;
  }) => any;
}) {
  const [mode, setMode] = useState<string>("view");
  const [inputComment, setInputComment] = useState<string>(comment.content);
  const [open, setOpen] = useState<boolean>(false);
  const { t } = useTranslation("common");

  const commentItems: MenuProps["items"] = useMemo(() => {
    return [
      {
        label: (
          <div>
            <IconShareCommentEdit />
            {t("Edit")}
          </div>
        ),
        key: "edit",
      },
      {
        label: (
          <div>
            <IconShareCommentDelete />
            {t("Delete")}
          </div>
        ),
        key: "delete",
      },
    ];
  }, [t]);

  const handleCommentOption = useCallback(
    (e: { key: string }) => {
      console.log(
        TAG,
        `handleCommentOption`,
        { comment },
        { key: e.key },
        { userProjectPermission }
      );

      if (userProjectPermission === "view") return;

      switch (e.key) {
        case "edit":
          console.log(TAG, `handleCommentOption edit `);
          setMode("edit");
          break;
        case "delete":
          console.log(TAG, `handleCommentOption delete `);
          setMode("delete");
          setOpen(true);
          break;
        default:
          break;
      }
    },
    [comment, userProjectPermission]
  );

  const handleDeleteOnOk = async (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    event.stopPropagation();
    event.preventDefault();
    if (handleDeleteComment) {
      const params = {
        projectId: comment.projectId,
        commentId: comment._id,
        type: "delete",
      };
      await handleDeleteComment(params);
      setOpen(false);
      // setMode('view')
    }
  };

  return (
    <StyledCommentDiv>
      {mode === "delete" && (
        <Modal
          width={300}
          open={open}
          onCancel={() => setOpen(false)}
          title={<span>{t("Delete Comment")}</span>}
          okText={<span>{t("Delete")}</span>}
          onOk={handleDeleteOnOk}
          centered
          closable
        >
          <div
            style={{ overflow: "auto", maxHeight: "100px", minHeight: "30px" }}
          >
            {comment.content}
          </div>
        </Modal>
      )}
      <div className="user-wrapper">
        <ProfileIcon>
          <span className="alphabet">
            {comment.userId.charAt(0).toUpperCase() || ""}
          </span>
        </ProfileIcon>
        <span className="user-id">{comment.userName}</span>
        {comment.videoTime !== null && (
          <div
            className="video-timer"
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
              if (handleVideoTime) {
                handleVideoTime(comment.videoTime);
              }
            }}
          >
            {comment.videoTime}
          </div>
        )}
        <span className="comment-date">
          {comment?.updatedAt
            ? formatTimeDifference(comment.updatedAt)
            : formatTimeDifference(comment.createdAt)}
        </span>
        {userProjectPermission !== "view" && (
          <span className="more-icon">
            <Dropdown
              menu={{
                items: commentItems,
                onClick: handleCommentOption,
              }}
              trigger={["click"]}
            >
              <EllipsisOutlined />
            </Dropdown>
          </span>
        )}
      </div>
      {mode === "view" && <div className="user-comment">{inputComment}</div>}
      {mode === "edit" && (
        <div className="edit-reply">
          <Input.TextArea
            rows={3}
            value={inputComment}
            placeholder="Leave a comment"
            onChange={(event: ChangeEvent<HTMLTextAreaElement>) =>
              setInputComment(event?.target?.value)
            }
            // onKeyDown={handleKeyDown}
            style={{ resize: "none", marginTop: "10px" }}
          />
          <div
            style={{
              width: "100%",
              display: "flex",
              marginTop: "5px",
              justifyContent: "flex-end",
            }}
          >
            <Button
              onClick={() => {
                setInputComment(comment.content)
                setMode("view");
              }}
            >
              {t("Cancel")}
            </Button>
            <Button
              style={{
                backgroundColor: "#3075f6",
                border: "1px solid #3075f6",
                borderRadius: "5px",
                color: "#ffffff",
                justifyContent: "center",
                display: "flex",
                alignItems: "center",
              }}
              onClick={(event) => {
                event.stopPropagation();
                event.preventDefault();
                if (handleEditComment) {
                  const params = {
                    commentId: comment._id,
                    content: inputComment,
                    videoTime: comment.videoTime,
                    type: "update",
                    projectId: comment.projectId,
                  };
                  handleEditComment(params);
                  setMode("view");
                }
              }}
            >
              {t("Edit")}
            </Button>
          </div>
        </div>
      )}
    </StyledCommentDiv>
  );
}
